function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "82",
  height: "70",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("rect", {
  x: "11",
  y: "18",
  width: "24",
  height: "3",
  rx: "1.5",
  fill: "#F3F2FC"
}), React.createElement("rect", {
  x: "11",
  y: "25",
  width: "24",
  height: "3",
  rx: "1.5",
  fill: "#F3F2FC"
}), React.createElement("rect", {
  x: "11",
  y: "11",
  width: "24",
  height: "3",
  rx: "1.5",
  fill: "#F3F2FC"
}), React.createElement("rect", {
  x: "11",
  y: "11",
  width: "18",
  height: "3",
  rx: "1.5",
  fill: "#80C"
}), React.createElement("rect", {
  x: "11",
  y: "18",
  width: "12",
  height: "3",
  rx: "1.5",
  fill: "#80C"
}), React.createElement("rect", {
  x: "11",
  y: "25",
  width: "6",
  height: "3",
  rx: "1.5",
  fill: "#80C"
}), React.createElement("rect", {
  x: "47",
  y: "18",
  width: "24",
  height: "3",
  rx: "1.5",
  fill: "#F3F2FC"
}), React.createElement("rect", {
  x: "47",
  y: "25",
  width: "24",
  height: "3",
  rx: "1.5",
  fill: "#F3F2FC"
}), React.createElement("rect", {
  x: "47",
  y: "11",
  width: "24",
  height: "3",
  rx: "1.5",
  fill: "#F3F2FC"
}), React.createElement("rect", {
  width: "18",
  height: "3",
  rx: "1.5",
  transform: "matrix(1 0 0 -1 47 28)",
  fill: "#80C"
}), React.createElement("rect", {
  width: "12",
  height: "3",
  rx: "1.5",
  transform: "matrix(1 0 0 -1 47 21)",
  fill: "#80C"
}), React.createElement("rect", {
  width: "6",
  height: "3",
  rx: "1.5",
  transform: "matrix(1 0 0 -1 47 14)",
  fill: "#80C"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 0a3 3 0 00-3 3v64a3 3 0 003 3h76a3 3 0 003-3V3a3 3 0 00-3-3H3zM2 3a1 1 0 011-1h76a1 1 0 011 1v64a1 1 0 01-1 1H3a1 1 0 01-1-1V3zm9 41.5c3.502-2.24 11.068-6.5 14.266-6.5 2.238 0 5.83 5.18 8.987 9.736 2.478 3.574 4.69 6.764 5.77 6.764 1.187 0 4.239-2.929 7.53-6.087 3.534-3.392 7.344-7.048 9.413-7.623l.13-.036C61.088 39.644 67.004 38 70.955 38c.071 4.312.04 10.267.017 14.694-.009 1.733-.017 3.231-.017 4.306H11V44.5z",
  fill: "url(#svg2636750062__paint0_linear)"
}), React.createElement("defs", null, React.createElement("linearGradient", {
  id: "svg2636750062__paint0_linear",
  x1: "41",
  x2: "41",
  y2: "70",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})))));